import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  AgentsConfiguration,
  EWalletConfiguration,
  NotificationsConfiguration,
  PaymentCenterConfiguration,
} from '@/models';
import { environment } from '@/environments/environment';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  constructor(private httpClient: HttpClient) {}

  public loadConfiguration(clientId: number | string) {
    const requestUri = new URL(
      `${environment.serviceEndpoints.clients}${clientId}/configuration`,
      environment.servicesRoot,
    ).toString();

    return this.httpClient
      .get<{
        agents: AgentsConfiguration;
        client: any; // eslint-disable-line @typescript-eslint/no-explicit-any
        ewallet: EWalletConfiguration;
        notifications: NotificationsConfiguration;
        paymentCenter: PaymentCenterConfiguration;
      }>(requestUri)
      .pipe(
        catchError((error) => {
          throw {
            upstreamError: error,
            clientId,
          };
        }),
      );
  }
}
